import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Clock3 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id") || params.get("session_id");
  const [tx, setTx] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orderId) {
      setLoading(false);
      return;
    }

    // Cashfree redirects back to return_url for both successful and
    // unsuccessful/user-dropped payment attempts. Always verify the
    // order server-side before showing "Booking confirmed".
    api.post("/payments/verify", { order_id: orderId })
      .then(({ data }) => setTx(data))
      .catch(() =>
        api.get(`/payments/status/${orderId}`).then(({ data }) => setTx(data)).catch(() => {})
      )
      .finally(() => setLoading(false));
  }, [orderId]);

  const status = tx?.payment_status;
  const paid = status === "paid";
  const failed = status === "failed" || status === "cancelled";
  const pending = status === "pending";

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      {paid ? (
        <CheckCircle2 className="h-16 w-16 text-accent mx-auto mb-4" />
      ) : failed ? (
        <XCircle className="h-16 w-16 text-destructive mx-auto mb-4" />
      ) : (
        <Clock3 className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
      )}

      <h1 className="heading-serif text-4xl mb-2">
        {paid ? "Booking confirmed" : failed ? "Payment failed" : "Payment pending"}
      </h1>

      <p className="text-muted-foreground mb-6">
        {paid
          ? `Your booking for ${tx.destination_name} is paid — ₹${Number(tx.amount).toLocaleString("en-IN")}.`
          : failed
            ? "Your payment was not completed. No successful payment was recorded for this booking. You can try again anytime."
            : loading
              ? "Checking the payment status..."
              : pending
                ? "Your payment is still being processed. Please wait a moment and check your dashboard again."
                : "We could not confirm a successful payment. Please try again."}
      </p>

      <Button asChild variant={paid ? "default" : "outline"} className={paid ? "rounded-full bg-accent text-accent-foreground" : "rounded-full"}>
        <Link to={paid ? "/dashboard" : "/"}>{paid ? "Go to dashboard" : "Back home"}</Link>
      </Button>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      <XCircle className="h-16 w-16 text-destructive mx-auto mb-4" />
      <h1 className="heading-serif text-4xl mb-2">Payment cancelled</h1>
      <p className="text-muted-foreground mb-6">No charge was made. You can try again anytime.</p>
      <Button asChild variant="outline" className="rounded-full"><Link to="/"><span>Back home</span></Link></Button>
    </div>
  );
}
